var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-container" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  ref: "queryFormRef",
                  attrs: { model: _vm.queryParams, inline: "" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.queryParams.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "name", $$v)
                          },
                          expression: "queryParams.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品条码", prop: "barcode" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.queryParams.barcode,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "barcode", $$v)
                          },
                          expression: "queryParams.barcode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "最小库存数", prop: "minStockQty" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          max:
                            _vm.queryParams.maxStockQty !== undefined
                              ? _vm.queryParams.maxStockQty - 1
                              : Infinity,
                          step: 1,
                        },
                        model: {
                          value: _vm.queryParams.minStockQty,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "minStockQty", $$v)
                          },
                          expression: "queryParams.minStockQty",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "最大库存数", prop: "maxStockQty" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min:
                            _vm.queryParams.minStockQty !== undefined
                              ? _vm.queryParams.minStockQty + 1
                              : 1,
                          step: 1,
                        },
                        model: {
                          value: _vm.queryParams.maxStockQty,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "maxStockQty", $$v)
                          },
                          expression: "queryParams.maxStockQty",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onQuery },
                        },
                        [_vm._v("查询")]
                      ),
                      _c("el-button", { on: { click: _vm.onReset } }, [
                        _vm._v("重置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                height: "calc(100vh - 380px)",
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "goodsId",
                  label: "商品ID",
                  width: "90",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "brand", label: "商品品牌", width: "200" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsName",
                  label: "商品名称",
                  "min-width": "400",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "spec", label: "商品规格", width: "250" },
              }),
              _c("el-table-column", {
                attrs: { prop: "barcode", label: "商品条码", width: "150" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "stockQty",
                  label: "库存数量",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class:
                              scope.row.stockQty === 0
                                ? "text-placeholder"
                                : "text-main",
                          },
                          [_vm._v(_vm._s(scope.row.stockQty))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  align: "center",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.parseTime(scope.row.createTime)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  align: "center",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.parseTime(scope.row.updateTime)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !!scope.row.stockQty &&
                        _vm.checkPermi(["admin:stock:update"])
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onUnpack(scope.row)
                                  },
                                },
                              },
                              [_vm._v("拆箱")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "mt16", attrs: { type: "flex", justify: "end" } },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.queryParams.limit,
                  "current-page": _vm.queryParams.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.onPageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("Unpack", { ref: "unpackRef", on: { success: _vm.getList } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }